import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-hospital-building",
  templateUrl: "./med-icon-hospital-building.component.html",
})
export class MedIconHospitalBuildingComponent extends SvgMixinComponent {}
